const ServiceTimeslot = function () {
    const SERVICE_TYPE_ECOMM_DELIVERY = 'HOME_DELIVERY';
    const SERVICE_TYPE_ECOMM_PICKUP = 'PICK_UP_IN_STORE';
    let selectedTimeslotId;
    let closeServiceAndTimeslotCallback;
    let cartStoreHasChanged = false;
    let cartTypeHasChanged = false;
    let cartHasStore = false;
    let serviceAndTimeslotClass = '#modal-service-and-timeslot';
    let productToAddToCart;
    let errorBoxForAddToCart;

    function init() {
        $('.openStoreLocator').click(function () {
            openServiceAndTimeslot.bind(this)();
        });

        $('.openBanner').click(function () {
            openServiceAndTimeslotBanner();
        });

        if (isServiceTimeslotWebviewMode()) {
            bindWebviewEvents();
        }

        stickyTimeslotBanner();

        if (!isServiceTimeslotWebviewMode()) {
            sidePanelControl.remodalCloseEvent();
        }
    }

    //!****************************************************************
    // Ajax calls
    //!****************************************************************

    function openModalServiceAndTimeslot(url) {

        let $isModalOpen = $('.st_panel.remodal-is-opened');
        if (!$isModalOpen.length) {
            openServiceTimeslot();
        } else {
            $isModalOpen.addClass('in-progress');
        }

        $.ajax({
            url: url,
            type: 'GET',
            contentType: 'application/json',
            dataType: 'html',
            cache: false,
            success: function (data, code, jqXHR) {
                replaceContentModalServiceAndTimeslot(data, false);
            },
            error: function (jqXHR) {
                TINK.redirectIfConflict(jqXHR);
            }
        });
    }

    function assignStoreAndTimeslotToCart(serviceTypeChosen, storeId, deliveryPostalCode, servicePointId, partnerCode, captchaEnabledAndInvisible) {
        deactivateServiceAndTimeslotButtons();
        let recaptchaResponse = serviceCaptcha.getResponse();
        let formStateId = $(serviceAndTimeslotClass + ' .st--main').attr('data-form-state-id');
        $.ajax({
            url: assignStoreAndTimeslotToCartUrl,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'html',
            data: JSON.stringify({
                'serviceType': serviceTypeChosen,
                'storeId': storeId,
                'deliveryPostalCode': deliveryPostalCode,
                'servicePointId': servicePointId,
                'partnerCode': partnerCode,
                'g-recaptcha-response': recaptchaResponse,
                'formStateId': formStateId,
                'captchaEnabledAndInvisible': captchaEnabledAndInvisible
            }),
            cache: false,
            success: function (data, code, jqXHR) {
                updateCartHasStore(jqXHR);
                updateCartWithoutTimeslot(false);
                updateHeaderAfterServiceAndTimeslotRequest(jqXHR);

                if (jqXHR.getResponseHeader('closeModal') === 'true') {
                    hideModalServiceAndTimeslot(true);

                    if (isInWebview()) {
                        sendWebviewReloadCartToDevice();
                    }
                } else {
                    replaceContentModalServiceAndTimeslot(data, false);
                }

                if (jqXHR.getResponseHeader('cartStoreHasChanged') === 'true') {
                    cartStoreHasChanged = true;
                }
                if (jqXHR.getResponseHeader('cartTypeHasChanged') === 'true') {
                    cartTypeHasChanged = true;
                }

                if (typeof serviceType != 'undefined') {
                    serviceType = jqXHR.getResponseHeader('cartServiceType');
                }

                if (jqXHR.getResponseHeader('timeslotError') !== 'true' && jqXHR.getResponseHeader('recaptchaFailed') !== 'true') {
                    hideModalServiceAndTimeslot(true);
                }

                $('#closeServiceAndTimeslotModal').attr('disabled', false);
            },
            error: function (jqXHR) {
                if (jqXHR.status === 400) {
                    if (jqXHR.getResponseHeader('cartStoreHasChanged') === 'true') {
                        cartStoreHasChanged = true;
                    }
                    if (jqXHR.getResponseHeader('cartTypeHasChanged') === 'true') {
                        cartTypeHasChanged = true;
                    }
                    if (jqXHR.getResponseHeader('recaptchaFailed') === 'true') {
                        displayCaptchaError($('#serviceCaptchaError'));
                        updateHeaderAfterServiceAndTimeslotRequest(jqXHR);
                        $(serviceAndTimeslotClass).find('button').not('footer button').attr('disabled', false);
                        serviceCaptcha.resetCaptcha();
                        return false;
                    }
                    updateCartHasStore(jqXHR);
                    updateHeaderAfterServiceAndTimeslotRequest(jqXHR);
                    $(serviceAndTimeslotClass).find('button').not('footer button').attr('disabled', false);
                    serviceCaptcha.resetCaptcha();
                } else {
                    TINK.redirectIfConflict(jqXHR);
                }
            }
        });
    }

    //!****************************************************************
    // Modal management
    //!****************************************************************

    function openServiceAndTimeslotBanner() {
        let $bannerServiceAndTimeslot = $("#banner-service-and-timeslot");
        if (isBannerServiceAndTimeslotOpen()) {
            $bannerServiceAndTimeslot.addClass('reduced');
        } else {
            $bannerServiceAndTimeslot.removeClass('reduced');
        }
    }

    function openServiceAndTimeslot(postalCode, product, errorBox, serviceTypeFromOverlay, origin) {
        cartStoreHasChanged = false;
        cartTypeHasChanged = false;
        productToAddToCart = product;
        errorBoxForAddToCart = errorBox;
        let $this;
        if (postalCode != null) {
            $this = $(postalCode);
        } else {
            $this = $(this);
        }

        let url = $this.data('target');
        let $postalCodeAttr = $this.attr('service-timeslot-postalcode');
        let fromSubmit = $this.attr('from-submit');
        if (!fromSubmit) {
            fromSubmit = false;
        }

        if (url) {
            if (postalCode !== undefined) {
                url += '?deliveryPostalCode=' + postalCode + '&fromSubmit=' + fromSubmit;
            } else if (typeof $postalCodeAttr != 'undefined') {
                url += '?deliveryPostalCode=' + $postalCodeAttr + '&fromSubmit=' + fromSubmit;
            } else {
                url += '?fromSubmit=' + false;
            }
        } else {
            url = $this.attr('service-and-timeslot-target');
            let $postalCodeAttr = $this.attr('service-timeslot-postalcode');
            if (typeof $postalCodeAttr != 'undefined') {
                url += '?deliveryPostalCode=' + $postalCodeAttr + '&fromSubmit=' + fromSubmit;
            } else {
                url += '?fromSubmit=' + fromSubmit;
            }
        }

        if (typeof serviceTypeFromOverlay != 'undefined') {
            url += '&serviceTypeFromOverlay=' + serviceTypeFromOverlay;
            serviceType = checkServiceType(serviceType);
        }

        closeServiceAndTimeslotCallback = $this.data('onstoreselectclose');
        if (!closeServiceAndTimeslotCallback || closeServiceAndTimeslotCallback === "") {
            closeServiceAndTimeslotCallback = null;
        }

        if (inCheckoutOrCart === true) {
            origin = 'checkout screen';
            serviceType = checkServiceType(serviceType);
        } else if (origin !== 'product tile overlay') {
            origin = 'sticky bar';
            serviceType = checkServiceType(serviceType);
        }

        gaPushOnPanelView(serviceType, origin);
        openModalServiceAndTimeslot(url);
    }

    function isBannerServiceAndTimeslotOpen() {
        return !$('#banner-service-and-timeslot').hasClass('reduced');
    }

    function replaceContentModalServiceAndTimeslot(data, closeModal) {
        replaceSection(data);
        if (!closeModal) {
            initPostalCodeFormContainer();
            bindServiceFlow();
            initServiceTimeslot();
            if (isServiceTimeslotWebviewMode()) {
                bindCloseButton();
            }
            manageFooterButtonsStates();
            manageFooterStoreSelect();
            manageStoreSelect();
            getToggleServiceType();
            bindCaptcha();
        }
    }

    function replaceSection(data) {
        data = data.trim();
        let $modal = $('#modal-service-and-timeslot');
        let $replaceSection = $modal.find('.replaceMePlease');
        if ($replaceSection.length > 0) {
            $replaceSection.html('');
        }

        $replaceSection.html(data);

        let $postalCodeInput = $('#deliveryPostalCode');
        if (data !== '') {
            $postalCodeInput.focus();
        }
    }

    function hideModalServiceAndTimeslot(success) {
        if (isServiceTimeslotWebviewMode()) {
            let status = success ? 'CONFIRMATION' : 'CANCELLATION';
            sendCloseWebviewEventToDevice(status);
        } else {
            closeServiceTimeslot();
        }
    }

    function initPostalCodeFormContainer() {
        let $deliveryPostalCodeInput = $('#deliveryPostalCode');
        let $postalCodeFormContainer = $(serviceAndTimeslotClass + ' form.st__postalCode');
        $postalCodeFormContainer.submit(function (e) {
            e.preventDefault();
            openModalServiceAndTimeslot.bind(this)(serviceUrl + '?deliveryPostalCode=' + $deliveryPostalCodeInput.val() + '&fromSubmit=' + true);
            return false;
        });
    }

    function bindServiceFlow() {
        $('#confirmTimeslot').click(function () {
            submitAssignStore();
            let serviceType = getToggleServiceType();
            serviceType = checkServiceType(serviceType);
            gaPushOnPanelClick(serviceType);
        });
    }

    function bindCaptcha() {
        serviceCaptcha.removeCaptcha();
        serviceCaptcha.renderCaptcha();
    }

    function submitAssignStore() {
        if (serviceCaptcha.isEnabledAndInvisible()) {
            serviceCaptcha.executeCaptcha();
        } else {
            findInfoAndAssignStoreToCart();
        }
    }

    window['executeFindInfoAndAssignStoreToCart'] = function (token) {
        findInfoAndAssignStoreToCart();
    }

    function findInfoAndAssignStoreToCart() {
        let partnerCode;
        if (window['partnerCollection'] || window['partnerCollection'] != null) {
            partnerCode = window['partnerCollection'].partnerCode;
        }

        let storeId;
        let deliveryPostalCode;
        let servicePointId;
        let serviceType;
        let $serviceTypeInput = getToggleServiceType();

        if ($serviceTypeInput === SERVICE_TYPE_ECOMM_DELIVERY) {
            serviceType = SERVICE_TYPE_ECOMM_DELIVERY;
            let $deliveryStore = $(serviceAndTimeslotClass + ' input[name="deliveryStore"]');
            storeId = $deliveryStore.attr('data-store-id');
            deliveryPostalCode = $deliveryStore.attr('data-delivery-postal-code');
            servicePointId = $deliveryStore.attr('data-service-point-id');
            pushDataLayerServiceAndTimeslotDelivery($deliveryStore.attr('data-store-name'));
        } else if ($serviceTypeInput === SERVICE_TYPE_ECOMM_PICKUP) {
            serviceType = SERVICE_TYPE_ECOMM_PICKUP;
            let $pickupStore = $(serviceAndTimeslotClass + ' input[name="pickUpStoreSelect"]:checked');
            storeId = $pickupStore.attr('data-store-id');
            servicePointId = $pickupStore.attr('data-pickup-service-point-id');
            deliveryPostalCode = $pickupStore.attr('data-delivery-postal-code');
            pushDataLayerServiceAndTimeslotPickup($pickupStore.attr('data-store-name'));
        } else {
            return;
        }

        let captchaEnabledAndInvisible = serviceCaptcha.isEnabledAndInvisible();
        assignStoreAndTimeslotToCart(serviceType, storeId, deliveryPostalCode, servicePointId, partnerCode, captchaEnabledAndInvisible);
    }

    function bindCloseButton() {
        //Define handler for close event
        $('#closeServiceAndTimeslotModal').unbind().click(function () {
            let serviceType = getToggleServiceType();
            serviceType = checkServiceType(serviceType);
            gaPushOnPanelClose(serviceType);
            hideModalServiceAndTimeslot(false);
        });
        $('#modal-service-and-timeslot .remodal-wrapper').unbind().on('mousedown', function (e) {
            let $parentIgnoreNode = document.querySelector('.st_panel');
            if (e.target !== $parentIgnoreNode && !$parentIgnoreNode.contains(e.target) && e.target.id !== 'closeServiceAndTimeslotModal') {
                hideModalServiceAndTimeslot(false);
            }
        });
    }

    function manageFooterButtonsStates() {
        let hasService = $('#noService').length > 0;
        let emptyPostalCode = $('#deliveryPostalCode').val() === '';
        sidePanelControl.disableConfirmTimeslotButton(hasService || emptyPostalCode);

    }

    function onCloseModalServiceAndTimeslot() {
        if (!cartHasStore) {
            window['cartItem'] = null;
        }

        if (window['changeTimeslot']) {
            window['storeId'] = false;
            window['changeTimeslot'] = false;
        }

        let reloadPageAuthorized = true;
        if (window['cartItem'] && !window['storeId']) {
            if (Array.isArray(productToAddToCart) ) {
                window['executeAddProductToCart'](productToAddToCart, errorBoxForAddToCart, false);
            } else {
                window['executeAddProductToCart'](productToAddToCart.closest('.item-addToCart'), errorBoxForAddToCart, false);
            }
        }

        if (isReloadPageAuthorizedForServiceAndTimeslot(reloadPageAuthorized)) {
            if (isInCheckoutPage()) {
                TINK.inProgress($('body'));
            }
            reloadPage();
            return;
        }

        if (closeServiceAndTimeslotCallback && closeServiceAndTimeslotCallback !== 'reloadPage') {
            let closeCallBack = eval(closeServiceAndTimeslotCallback);
            if (typeof closeCallBack === 'function') {
                closeCallBack(selectedTimeslotId);
            }
        }
        closeServiceAndTimeslotCallback = null;

        replaceContentModalServiceAndTimeslot('', true);
    }

    function isReloadPageAuthorizedForServiceAndTimeslot(reloadPageAuthorized) {
        return (reloadPageAuthorized && cartStoreHasChanged) || (window.location.pathname === shoppingCartUrl) || (cartTypeHasChanged && isInCheckoutPage());
    }

    //!****************************************************************
    // Util
    //!****************************************************************

    function deactivateServiceAndTimeslotButtons($container) {
        if ($container === undefined) {
            $container = $(serviceAndTimeslotClass);
        }
        $container.find('button').attr('disabled', true);
    }
    function isServiceTimeslotWebviewMode() {
        return isInWebview() && typeof serviceTimeslotWebviewMode !== 'undefined' && serviceTimeslotWebviewMode;
    }

    function bindWebviewEvents() {
        if (isAuthenticated) {
            $('#openServiceForm').click();
        } else {
            // send event to redirect to connection page in the App
            sendUserNotAuthenticatedEventToDevice();
        }
    }

    function manageFooterStoreSelect() {
        let currentServiceType = getToggleServiceType();
        let $selectedStore;
        let $storeName;
        let $storeAddress;
        if (currentServiceType === SERVICE_TYPE_ECOMM_PICKUP) {
            $selectedStore = $('.store--list input:checked');
            $storeName = $selectedStore.data('store-name');
            $storeAddress = $selectedStore.data('store-address');
            $('.sp_footer-store-name').html($storeName, ' ', $storeAddress);
            sidePanelControl.submitActivation();
        }
    }

    function manageStoreSelect() {
        $('.store--list input').on('change', function() {
            manageFooterStoreSelect();
        });
    }

    function getToggleServiceType() {
        return $(serviceAndTimeslotClass + ' input[name="radioServiceType"]:checked').val();
    }

    function checkServiceType(serviceType) {
        if (typeof serviceType == 'undefined') {
            serviceType = 'none';
        } else if (serviceType.toUpperCase() === 'HOME_DELIVERY') {
            serviceType = 'delivery';
        } else if (serviceType === 'PICK_UP_IN_STORE' || serviceType === 'pickup') {
            serviceType = 'pick-up';
        } else {
            serviceType = 'none';
        }
        return serviceType;
    }

    //!****************************************************************
    // Update dom
    //!****************************************************************

    function updateCartHasStore(jqXHR) {
        cartHasStore = jqXHR.getResponseHeader('cartHasStore') === 'true';
    }

    function updateCartWithoutTimeslot(timeslotSelected) {
        cartWithoutTimeslot = timeslotSelected;
    }

    function displayCaptchaError($alertElem) {
        if ($alertElem.length) {
            $alertElem.show();
            $alertElem.children('ul').attr('tabindex', '1');
            $alertElem.children('ul').focus();
        }
    }

    function updateHeaderAfterServiceAndTimeslotRequest(jqXHR) {
        if (jqXHR.getResponseHeader('updateHeader') === 'true') {
            updateHeaderAfterServiceAndTimeslot(jqXHR.getResponseHeader('updateHeaderStore'),
                jqXHR.getResponseHeader('updateHeaderPostalCode'),
                jqXHR.getResponseHeader('updateHeaderTimeslot'),
                jqXHR.getResponseHeader('updateHeaderPickup') === 'true');

        }
    }

    function updateHeaderAfterServiceAndTimeslot(storeName, postalCode, timeSlot, forPickup) {
        if ($('#banner-service-and-timeslot').length) {
            if (storeName) {
                if (forPickup) {
                    $('.openStoreLocatorPickup').attr('service-timeslot-postalcode', postalCode);
                    $('.action__edit--service  .openStoreLocatorTimeslot').attr('service-timeslot-postalcode', storeName);
                    $('.locationPickup .openStoreLocatorName').text(storeName);
                    $('.locationPickup').removeClass('hide');
                    $('.openStoreLocatorPickup').removeClass('hide');
                    $('.openStoreLocatorDelivery').addClass('hide');
                    $('.openStoreLocatorPickup').closest('span.action__edit--service').removeClass('hide').addClass('text-same-line');
                    $('.icon--service-template.openBanner').find('img').attr("src", "/magasiner/images/icon/logo/icon-service-pickup.svg");
                } else {
                    $('.openStoreLocatorDelivery').attr('service-timeslot-postalcode', postalCode);
                    $('.locationPickup .openStoreLocatorName').text('');
                    $('.openStoreLocatorDelivery .openStoreLocatorName').text(storeName).mask('S0S 0S0');
                    $('.openStoreLocatorDelivery').removeClass('hide');
                    $('.openStoreLocatorPickup').addClass('hide');
                    $('.openStoreLocatorDelivery').closest('span.action__edit--service').removeClass('hide').addClass('text-same-line');
                    $('.icon--service-template.openBanner').find('img').attr("src", "/magasiner/images/icon/logo/icon-service-delivery.svg");
                }
                $('.action__add-to-cart').attr('service-timeslot-postalcode', postalCode);

                $('.action__select--service.serviceText').addClass('hide');
                $('.action__select--service.openStoreLocatorTimeslotWrapper').addClass('hide');
                $('.ipDetection, .favoriteStore').addClass('hide');
                $('.action__edit--service.openStoreLocatorTimeslotWrapper').removeClass('hide').addClass('text-same-line');
                $('.action__edit--service .openStoreLocatorTimeslot').attr('service-timeslot-postalcode', postalCode);
            }
        }
    }

    function isModalServiceAndTimeslotOpen() {
        return $('.st_panel.remodal-is-opened').length;
    }

    //****************************************************************
    // Expose
    //****************************************************************

    return {
        init: init,
        bindCaptcha: bindCaptcha,
        openServiceAndTimeslot: openServiceAndTimeslot,
        updateHeaderAfterServiceAndTimeslotRequest: updateHeaderAfterServiceAndTimeslotRequest,
        onCloseModalServiceAndTimeslot: onCloseModalServiceAndTimeslot,
        updateCartHasStore: updateCartHasStore,
        isModalServiceAndTimeslotOpen: isModalServiceAndTimeslotOpen,
        updateCartWithoutTimeslot: updateCartWithoutTimeslot,
        bindCloseButton: bindCloseButton,
        manageFooterStoreSelect: manageFooterStoreSelect,
        getToggleServiceType: getToggleServiceType,
        SERVICE_TYPE_ECOMM_DELIVERY: SERVICE_TYPE_ECOMM_DELIVERY,
        SERVICE_TYPE_ECOMM_PICKUP: SERVICE_TYPE_ECOMM_PICKUP
    }
}();

const stickyTimeslotBanner = function () {
    let $bannerServiceAndTimeslot = $('#banner-service-and-timeslot');


    if ($bannerServiceAndTimeslot.length >= 1 && !Revealizr.isMobileSize) {
        let viewportTop = 0;

        const changeStateOnScroll = function () {
            viewportTop = $(window).scrollTop();
            if (viewportTop > 30) {
                $bannerServiceAndTimeslot.addClass('reduced');
            } else {
                $bannerServiceAndTimeslot.removeClass('reduced');
            }
        };

        changeStateOnScroll();
        $(window).on('scroll', _.debounce(changeStateOnScroll, 200));
    }
}

$(document).ready(function () {
    ServiceTimeslot.init();
});